module.exports = __webpack_public_path__ + "static/img/img22.767f67b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img22.png
// module id = 7jkl
// module chunks = 18